import { TextField } from "@mui/material";
import { DatePicker } from "@mui/x-date-pickers";
import { useField, useFormikContext } from "formik";
import { buildArtFieldLabel } from "./artFieldLabelUtils";
import { useArtFieldMetadata } from "./artFieldMetadataContext";

const FormikDatePicker = (props) => {
  const [field, meta] = useField(props);
  const { setFieldValue } = useFormikContext();
  const fieldMetadata = useArtFieldMetadata(props.name);
  const label = buildArtFieldLabel(props.label, fieldMetadata);

  // Si no hay valor, usa null para que no haya valor predeterminado
  const value = field.value ? new Date(field.value) : null;

  const handleChange = (value) => {
    setFieldValue(props.name, value);
    if (props.callBack) {
      props.callBack(value);
    }
  };

  return (
    <DatePicker
      ampm={"false"}
      format="dd/MM/yyyy"
      autoOk={true}
      variant="inline"
      value={value}
      slotProps={{
        textField: {
          variant: props.variant || "standard",
          fullWidth: true,
          error: meta.touched && !!meta.error,
          helperText: meta.touched && meta.error ? meta.error : null,
        },
        actionBar: {
          actions: ['clear'],
        },
      }}
      localeText={{ clearButtonLabel: "Borrar" }}
      {...props}
      label={label}
      error={meta.touched && meta.error ? true : false}
      helperText={meta.touched && meta.error ? meta.error : null}
      onChange={handleChange}
      cancelLabel={props.disabledButtons ? "" : undefined}
      okLabel={props.disabledButtons ? "" : undefined}
      KeyboardButtonProps={{
        "aria-label": "change date",
      }}
      renderInput={(params) => (
        <TextField
          {...params}
          inputProps={{
            ...params.inputProps,
            placeholder: "",
          }}
        />
      )}
    />
  );
};

export default FormikDatePicker;
